export default {
    name: 'Glowforge:BlogRecentPosts',
    friendlyName: 'Blog Recent Posts',
    image: 'https://cdn.builder.io/api/v1/image/assets%2F69fac0673d2644f0a0a962e1cb3045ef%2F5d4ee850b6364352b7839ae17b33197a',
    noWrap: true,
};
